import { Box } from 'ui/Layout';

// This component is used by measureText() method to calculate label sizes
// before positioning the nodes in the Sankey diagram.
const SVGScratch: React.FC = () => (
  <Box position="absolute" visibility="hidden" zIndex="hide">
    <svg id="svg_scratch" xmlns="http://www.w3.org/2000/svg" />
  </Box>
);

export default SVGScratch;
